import { SELECIONAR_VIAGEM } from '../../actions/types'

const initialState = undefined

export default function reducerSelecionarViagem (state = [], action = initialState) {
  switch (action.type) {
    case SELECIONAR_VIAGEM: {
      return action.payload;
    }

    default: {
      return state
    }
  }
}
